import constants from '../constants'
import axios from 'axios';
import qs from 'qs';

export const ajax = (params) => {
  let instance = axios.create({
    baseURL: constants.API.ENTRYPOINT,
    headers: {
      "Content-type": "application/json",
    },
    paramsSerializer: params => qs.stringify(params, { arrayFormat: 'brackets' })
  });

  return instance(rebuildParams(params));
};

const rebuildParams = (params) => {
  let url = params.url;

  if (!!~url.indexOf(':id')) {
    if (typeof params.params.id == 'undefined') {
      console.error(url, 'must have param id');
    } else {
      params.url = url.replace(':id', params.params.id);
      delete params.params['id'];
    }
  }

  return params;
};


// WEBPACK FOOTER //
// ./app/javascript/app/api/tools.js